import { GetActivitiesParams } from "./activities.type";

export const ACTIVITIES_KEYS = {
  all: ["activities"] as const,
  lists: () => [...ACTIVITIES_KEYS.all, "list"] as const,
  list: (params?: GetActivitiesParams) =>
    [...ACTIVITIES_KEYS.lists(), params] as const,
  recent: (limit?: number) => [...ACTIVITIES_KEYS.all, "recent", limit] as const,
};
